import { getCurrentProductProfile } from '../../content/common/utils';
import {
  CONNECTOR_UI_DEFAULTS,
  PROFILE_CONNECTOR_UI,
} from '../../content/common/productProfiles';

const getConnectorUiConfig = () => {
  const profile = getCurrentProductProfile();
  return {
    ...CONNECTOR_UI_DEFAULTS,
    ...(PROFILE_CONNECTOR_UI[profile] || {}),
  };
};

const matchesAllowList = (allowList, connectorType, sourceId) => {
  if (!allowList) return true;
  const allowed = allowList[connectorType];
  if (!allowed) return true;
  return allowed.includes(sourceId);
};

/** Editable Sources tiles on the Connectors page — profile allow-list only. */
export const isConnectorVisible = (connectorType, sourceId) => {
  const { visibleConnectors } = getConnectorUiConfig();
  return matchesAllowList(visibleConnectors, connectorType, sourceId);
};

/** Source ids shown as disabled, non-editable tiles (e.g. Highlights). */
export const getReadOnlyConnectors = connectorType => {
  const { readOnlyConnectors } = getConnectorUiConfig();
  if (!readOnlyConnectors) return [];
  return readOnlyConnectors[connectorType] || [];
};

/**
 * Configured Connector Details table.
 * Uses configuredConnectors when set; otherwise falls back to visibleConnectors.
 */
export const isConfiguredConnectorVisible = (connectorType, sourceId) => {
  const { configuredConnectors, visibleConnectors } = getConnectorUiConfig();

  if (configuredConnectors) {
    return matchesAllowList(configuredConnectors, connectorType, sourceId);
  }

  return matchesAllowList(visibleConnectors, connectorType, sourceId);
};
